import cn from 'classnames';

const SaleAgentCard = ({
  storeName,
  address,
  phone,
  city,
  state,
  onClick,
}: ISaleAgentCardProps) => {
  const saleAgentCardData = [
    {
      icon: 'icon-nameStore',
      data: storeName,
    },
    {
      icon: 'icon-nameLocation',
      data: address
        ? `${state?.name}, ${city?.name}, ${address}`
        : `${state?.name}, ${city?.name}`,
    },
    {
      icon: 'icon-styleoutline138',
      data: phone,
      class: 'text-farm-shop-500',
    },
  ];

  return (
    <div
      className="p-2 flex flex-col w-full border rounded-lg gap-2"
      onClick={onClick}
    >
      {saleAgentCardData.map(item => (
        <div className="flex items-center">
          <div
            className={cn(
              'w-8 h-8 flex justify-center items-center rounded-full bg-inherit',
              {
                '!bg-gray-50': item.icon === 'icon-nameStore',
              },
            )}
          >
            <i className={item.icon} />
          </div>

          <span
            className={cn('text-sm mr-4', item.class, {
              'font-medium': item.icon === 'icon-nameStore',
            })}
          >
            {item.data}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SaleAgentCard;
